import { useCallback, useState } from 'react';
import { StorageKeys, StorageUtilities } from '@dealstack/frontend/shared/helper/storageUtils.ts';
import { CardTableView } from '@dealstack/frontend/shared/components/CardTableViewSelector/CardTableViewSelector.types.ts';

export type PersistedViewKey =
	| StorageKeys.MIP_INVESTMENT_DETAILS_ALLOCATIONS_VIEW
	| StorageKeys.MIP_INVESTMENT_DETAILS_DOCUMENTS_VIEW
	| StorageKeys.MIP_PROGRAMME_EMAIL_TEMPLATES_VIEW
	| StorageKeys.MIP_INVESTOR_DETAILS_HOLDINGS_VIEW
	| StorageKeys.MIP_INVESTOR_DETAILS_DOCUMENTS_VIEW
	| StorageKeys.DEAL_EMAIL_TEMPLATES_VIEW
	| StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_HOLDINGS_VIEW
	| StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_DOCUMENTS_VIEW
	| StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_VIEW;

const isCardTableView = (value: unknown): value is CardTableView =>
	value === 'cards' || value === 'table';

export const usePersistedCardTableView = (
	storageKey: PersistedViewKey,
	defaultValue: CardTableView
): [CardTableView, (next: CardTableView) => void, boolean] => {
	const [chosenView, setChosenView] = useState<CardTableView | null>(() => {
		const stored = StorageUtilities.getItem<CardTableView>(storageKey);
		return isCardTableView(stored) ? stored : null;
	});
	const persistView = useCallback(
		(next: CardTableView) => {
			setChosenView(next);
			StorageUtilities.setItem(storageKey, next);
		},
		[storageKey]
	);

	return [chosenView ?? defaultValue, persistView, chosenView !== null];
};
